module.exports = __webpack_public_path__ + "static/media/new-solar-lamp.099db9be.png";